const React = require('react');
const Layout = require('./src/components/Layout').default;
const Transition = require('./src/components/Transition').default;

exports.wrapPageElement = ({element, props}) => {
	//console.log(`Browser: `, props)
	return (
		<Layout {...props}>
			<Transition {...props}>
				{element}
			</Transition>
		</Layout>
	)
}

exports.onRouteUpdate = ({location, prevLocation}) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': "previous_page",
		'page': location.pathname,
		'prevLocation': prevLocation ? prevLocation.pathname : null
	});
	window._ss = window._ss || [];
	window._ss.push(['_trackPageView']);
	
	if (prevLocation && typeof window.LF_track_load !== 'undefined') {
		window.LF_track_load(location.href, document.title);
	}
}